/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryListingBedroomCount
 */

import { isBedroomsSelected } from '@zcode-ui/filters'
import { bedroomCountToBoolArray } from '@zcode/nr/es/shared/utils/filter'
import type { Filters, ListableListing, Listing } from '@zcode/state-type'

export const getQueryListingBedroomCount = (
  entity: ListableListing | Listing,
  filters: Partial<Filters> | undefined
) => {
  const entityBedrooms = bedroomCountToBoolArray(entity ? entity.bedrooms : null)
  if (isBedroomsSelected(filters)) {
    return filters.bedrooms.reduce<[boolean, boolean, boolean, boolean, boolean, boolean]>(
      (bedrooms, val, i) => {
        bedrooms[i] = val || entityBedrooms[i]
        return bedrooms
      },
      [false, false, false, false, false, false]
    )
  }

  return entityBedrooms
}
